import React, { Fragment, useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import moment from 'moment'
import { ticketDataFormate } from '../../utils/formatedata'
import { COUNTRIES } from '../../utils/countries'
import industrys from '../../data/industry.json'
import { getDataTicket, sendDataHsForm } from '../../service/callAPI'
import { yupResolver } from '@hookform/resolvers/yup'
import schema from './schema'

import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  MenuItem,
  CircularProgress,
  Paper,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  Link,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormHelperText,
} from '@mui/material'
import Snackbar from '../../components/Snackbar'
import LogoBrand from '../../components/LogoBrand'
import DatepickerComponant from '../../components/DatepickerComponant'
import LoadingInformation from '../../components/LoadingInformation'
import FlagButton from '../../components/FlagButton'
import FlagsMenu from '../../components/FlagsMenu'

function Regisform() {
  const urlParams = new URLSearchParams(window.location.search)
  const [alert, setAlert] = useState({
    open: false,
    status: 'success',
    message: 'This is a success message!',
  })
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingData, setIsLoadingData] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [data, setData] = useState({})
  const [validateValue, setValidateValue] = useState(false)
  const [paramObj, setParamObj] = useState({})
  const [anchorEl, setAnchorEl] = useState(null)
  const textFieldRef = React.useRef(null)
  const [isoCode, setIsoCode] = useState('PH')

  const {
    control,
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    watch,
    setError,
  } = useForm({
    resolver: yupResolver(schema),
  })
  const watchAccept = watch('accept')
  const watchKnowHow = watch('know_how')
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))
  let checkStatusInterval
  const onSubmit = (values) => {
    setIsLoading(true)
    const phone = `+${COUNTRIES[isoCode]?.[0]} ${values.phone}`
    // console.log('onSubmit', { values, phone })

    // window.location.href = `thankyou?qrcode=${'555-XXX-ZXC'}`
    getDataTicket({
      action: 'da999d7a-c164-a21a-bcf7-32cb27298727',
      firstname: values.first_name,
      lastname: values.last_name,
      email: values.email,
      phone: phone,
      DATA_006: values.job_title,
      DATA_007: values.company_name,
      DATA_008: values.number_of_employees,
      DATA_009: values.industry,
      DATA_010: values.know_how,
      DATA_011: values.other,
      DATA_012: values.allow ? 'Yes' : 'No',
      DATA_013: values.accept ? 'Yes' : 'No',
      DATA_014: JSON.stringify(paramObj),
      event_id: 'da999d7a-c164-a21a-bcf7-32cb27298727',
    }).then(async (res) => {
      console.log('getDataTicket', res)
      if (res.code === 0) {
        // console.log(res)

        console.log('thankyou', res.data.code)
        if (res.data.code === 'reject') {
          window.location.href = `reject`
        } else if (res.data.code === 'ConditionalCheckFailedException') {
          setIsLoading(false)
          setAlert({
            open: true,
            status: 'error',
            message: 'This email was already registered',
          })
          setError('email', { type: 'custom', message: 'This email was already registered' })
        } else {
          setIsLoading(false)
          clearInterval(checkStatusInterval)
          setIsSuccess(true)
          setAlert({
            open: true,
            status: 'success',
            message: 'Register success!',
          })
          await sendDataHsForm({
            submittedAt: new Date().getTime(),
            fields: [
              {
                objectTypeId: '0-1',
                name: 'firstname',
                value: values.first_name,
              },
              {
                objectTypeId: '0-1',
                name: 'lastname',
                value: values.last_name,
              },
              {
                objectTypeId: '0-1',
                name: 'email',
                value: values.email,
              },
              {
                objectTypeId: '0-1',
                name: 'phone',
                value: phone,
              },
              {
                objectTypeId: '0-1',
                name: 'position',
                value: values.job_title,
              },
              {
                objectTypeId: '0-1',
                name: 'company',
                value: values.company_name,
              },
              {
                objectTypeId: '0-1',
                name: 'headcount',
                value: values.number_of_employees,
              },
              {
                objectTypeId: '0-1',
                name: 'sub_industry__sprout_official___forms_', //sub_industry__sprout_official___forms_
                value: values.industry,
              },
              {
                objectTypeId: '0-1',
                name: 'how_did_you_hear_about_this_event_', //how_did_you_hear_about_this_event_
                value: values.know_how,
              },
              {
                objectTypeId: '0-1',
                name: 'note', //note
                value: values.other ? values.other : '-',
              },
              {
                objectTypeId: '0-1',
                name: 'campaign_id',
                value: 'State of HR Event 06222023',
              },
              {
                objectTypeId: '0-1',
                name: 'by_checking_this_box__i_allow_sharing_my_from_details_with_event_partners', //by_checking_this_box__i_allow_sharing_my_from_details_with_event_partners
                value: 'Yes',
              },
              {
                objectTypeId: '0-1',
                name: 'receive_email_notifications', //receive_email_notifications
                value: 'Yes',
              },
            ],
            legalConsentOptions: {
              consent: {
                consentToProcess: values.allow ? true : false,
                text: 'I allow the event organizers to share my form details with event partners and sponsors for possible product/service-related announcemetns.',
                communications: [
                  {
                    value: values.accept ? true : false,
                    subscriptionTypeId: 999,
                    text: 'Send me Sprout event invites, newsletters, free eBooks, product offers, and other HR updates! I consent to Sprout Solutions processing my personal data in order to send personalized material in accordance with the Privacy Policy and Terms of Service.',
                  },
                ],
              },
            },
          }).then((resHS) => {
            console.log('sendDataHsForm', resHS)
          })
          window.location.href = `thankyou?qrcode=${res.data.code}`
        }
        // window.location.href = `thankyou?qrcode=${res.data.code}`
      } else {
        if (res.code === 97) {
          // ticket "already register"
          setAlert({
            open: true,
            status: 'error',
            message: 'Already register',
          })
          setIsLoading(false)
        } else if (res.code === 123 || res.code === 124) {
          //please confirm email show alert
          setAlert({
            open: true,
            status: 'warning',
            message: 'Wait for user confirm mail',
          })
          setIsLoading(false)
        } else {
          console.log('unknow error @alert')
          setAlert({
            open: true,
            status: 'error',
            message:
              'The reference code you entered was not found. Please try another reference code.',
          })
          setIsLoading(false)
        }
      }
    })
  }
  useEffect(() => {
    setIsLoadingData(false)
    const valueParam = {}
    for (let p of urlParams) {
      console.log(p)
      valueParam[p[0]] = p[1]
    }
    setParamObj(valueParam)
    console.log('qrStr', valueParam)
  }, [])
  // console.log('errors', data)
  const handleOpenFlagsMenu = (event) => {
    event.preventDefault()
    // console.log('handleOpenFlagsMenu', { event, textFieldRef: textFieldRef.current })
    setAnchorEl(textFieldRef.current)
  }
  const handleRef = (ref) => {
    textFieldRef.current = ref
  }
  const handleCloseFlagsMenu = () => {
    setAnchorEl(null)
  }
  const handleChangeCountry = (newCountry) => {
    setAnchorEl(null)
    // console.log('handleChangeCountry', newCountry)
    setIsoCode(newCountry)
  }

  return (
    <div>
      {/* <LogoBrand /> */}
      <form onSubmit={handleSubmit(onSubmit)}>
        {isLoadingData ? (
          <LoadingInformation />
        ) : (
          <Paper
            elevation={0}
            // customBorder
            sx={{
              p: 4.5,
            }}
          >
            {data.pre_detail ? (
              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  mt: 4,
                  backgroundColor: '#00853A',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#00853A', color: '#fff' },
                }}
                onClick={() => {
                  window.location.href = `thankyou?qrcode=${'qrCode'}`
                }}
              >
                Registered
              </Button>
            ) : (
              <Grid container spacing={2} sx={{ mt: 1.5 }}>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="first_name"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          id="input-name"
                          name="first_name"
                          label={
                            <Fragment>
                              <span>First name</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          placeholder="First name"
                          variant="standard"
                          error={errors?.first_name}
                          helperText={errors?.first_name?.message}
                          fullWidth
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        />
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="last_name"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          id="input-last-name"
                          name="last_name"
                          label={
                            <Fragment>
                              <span>Last name</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          placeholder="Last name"
                          variant="standard"
                          error={errors?.last_name}
                          helperText={errors?.last_name?.message}
                          fullWidth
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        />
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="email"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          id="input-email"
                          name="email"
                          label={
                            <Fragment>
                              <span>Email</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          placeholder="Email"
                          variant="standard"
                          error={errors?.email}
                          helperText={errors?.email?.message}
                          fullWidth
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        />
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography variant="body1" sx={{ color: '#33475b' }}>
                    We kindly ask that each registrant use a unique email address for registration.
                    Personal work emails are highly recommended, as the system cannot recognize
                    distribution lists.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="phone"
                    render={({ field }) => {
                      return (
                        <>
                          <TextField
                            {...field}
                            ref={handleRef}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FlagButton
                                    isFlagsMenuOpened={anchorEl}
                                    isoCode={isoCode}
                                    onClick={handleOpenFlagsMenu}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            id="input-phone"
                            name="phone"
                            label={
                              <Fragment>
                                <span>Phone number</span>
                                <span style={{ color: '#B30021' }}>*</span>
                              </Fragment>
                            }
                            placeholder="Phone number"
                            variant="standard"
                            error={errors?.phone}
                            helperText={errors?.phone?.message}
                            fullWidth
                            sx={{
                              '& .MuiInputLabel-root': {
                                color: '#33475b!important',
                              },
                              '& .MuiInput-root': {
                                color: '#33475b!important',
                              },
                              '& .Mui-focused': {
                                color: '#33475b',
                              },
                              '& :before': {
                                borderBottom: '1px solid #33475b!important',
                              },
                              '& :after': {
                                borderBottom: '2px solid #33475b!important',
                              },
                            }}
                          />
                          <FlagsMenu
                            anchorEl={anchorEl}
                            isoCode={isoCode}
                            onClose={handleCloseFlagsMenu}
                            onSelectCountry={handleChangeCountry}
                          />
                        </>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="job_title"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          id="input-job"
                          name="job_title"
                          label={
                            <Fragment>
                              <span>Job Title</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          placeholder="Job Title"
                          variant="standard"
                          error={errors?.job_title}
                          helperText={errors?.job_title?.message}
                          fullWidth
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        />
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="company_name"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          id="input-company"
                          name="company_name"
                          label={
                            <Fragment>
                              <span>Company name</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          placeholder="Company name"
                          variant="standard"
                          error={errors?.company_name}
                          helperText={errors?.company_name?.message}
                          fullWidth
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        />
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="number_of_employees"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          id="input-number"
                          name="number_of_employees"
                          label={
                            <Fragment>
                              <span>Number of Employees</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          placeholder="Number of Employees"
                          variant="standard"
                          error={errors?.number_of_employees}
                          helperText={errors?.number_of_employees?.message}
                          fullWidth
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        />
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="industry"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          select
                          fullWidth
                          label={
                            <Fragment>
                              <span>Industry</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          variant="standard"
                          error={errors?.industry}
                          helperText={errors.industry?.message}
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        >
                          {industrys.map((industry, index) => (
                            <MenuItem key={industry} value={industry}>
                              {industry}
                            </MenuItem>
                          ))}
                        </TextField>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Controller
                    control={control}
                    name="know_how"
                    render={({ field }) => {
                      return (
                        <TextField
                          {...field}
                          select
                          fullWidth
                          label={
                            <Fragment>
                              <span>How did you hear about this event?</span>
                              <span style={{ color: '#B30021' }}>*</span>
                            </Fragment>
                          }
                          variant="standard"
                          error={errors?.know_how}
                          helperText={errors.know_how?.message}
                          sx={{
                            '& .MuiInputLabel-root': {
                              color: '#33475b!important',
                            },
                            '& .MuiInput-root': {
                              color: '#33475b!important',
                            },
                            '& .Mui-focused': {
                              color: '#33475b',
                            },
                            '& :before': {
                              borderBottom: '1px solid #33475b!important',
                            },
                            '& :after': {
                              borderBottom: '2px solid #33475b!important',
                            },
                          }}
                        >
                          {[
                            'Social Media (Facebook, LinkedIn)',
                            'Website',
                            'Email/Newsletters',
                            'Invited by a sponsor or colleague (please specify)',
                            'Others (Please specify)',
                          ].map((how, index) => (
                            <MenuItem key={index} value={how}>
                              {how}
                            </MenuItem>
                          ))}
                        </TextField>
                      )
                    }}
                  />
                </Grid>
                {[
                  'Invited by a sponsor or colleague (please specify)',
                  'Others (Please specify)',
                ].includes(watchKnowHow) && (
                  <Grid item xs={12} md={12}>
                    <Controller
                      control={control}
                      name="other"
                      render={({ field }) => {
                        return (
                          <TextField
                            {...field}
                            id="input-other"
                            name="other"
                            label="For others, please indicate here"
                            placeholder="For others, please indicate here"
                            variant="standard"
                            error={errors?.other}
                            helperText={errors?.other?.message}
                            fullWidth
                            sx={{
                              '& .MuiInputLabel-root': {
                                color: '#33475b!important',
                              },
                              '& .MuiInput-root': {
                                color: '#33475b!important',
                              },
                              '& .Mui-focused': {
                                color: '#33475b',
                              },
                              '& :before': {
                                borderBottom: '1px solid #33475b!important',
                              },
                              '& :after': {
                                borderBottom: '2px solid #33475b!important',
                              },
                            }}
                          />
                        )
                      }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={12}>
                  <FormControl variant="standard" error={errors?.allow}>
                    <Controller
                      control={control}
                      name="allow"
                      render={(itemProps) => {
                        const { onChange, value } = itemProps.field
                        const handleChange = (e) => {
                          onChange(e.target.checked)
                        }
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...itemProps.field}
                                checked={value}
                                onChange={handleChange}
                                disableRipple
                                sx={{ color: '#33475b' }}
                              />
                            }
                            label={
                              <Typography variant="body2" sx={{ color: '#33475b' }}>
                                I allow the event organizers to share my form details with event
                                partners and sponsors for possible product/service-related
                                announcements.
                              </Typography>
                            }
                            disableTypography
                          />
                        )
                      }}
                    />
                    {errors?.allow && <FormHelperText>{errors?.allow?.message}</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                  <FormControl variant="standard" error={errors?.accept}>
                    <Controller
                      control={control}
                      name="accept"
                      render={(itemProps) => {
                        const { onChange, value } = itemProps.field
                        const handleChange = (e) => {
                          setValidateValue(e.target.checked)
                          onChange(e.target.checked)
                        }
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...itemProps.field}
                                checked={validateValue}
                                onChange={handleChange}
                                disableRipple
                                sx={{ color: '#33475b' }}
                              />
                            }
                            label={
                              <Typography variant="body2" sx={{ color: '#33475b' }}>
                                Send me Sprout event invites, newsletters, free eBooks, product
                                offers, and other HR updates! I consent to Sprout Solutions
                                processing my personal data in order to send personalized material
                                in accordance with the{' '}
                                <Link
                                  href="https://sprout.ph/privacy-policy/?__hstc=251652889.16f8f575fe5d62c23cdc810d9e1de750.1684385561302.1684385561302.1684387444061.2&__hssc=251652889.1.1684387444061&__hsfp=2270127248"
                                  target="_blank"
                                  sx={{ fontWeight: 'bold' }}
                                >
                                  Privacy Policy
                                </Link>{' '}
                                and{' '}
                                <Link
                                  href="https://sprout.ph/terms-of-service/?__hstc=251652889.16f8f575fe5d62c23cdc810d9e1de750.1684385561302.1684385561302.1684387444061.2&__hssc=251652889.1.1684387444061&__hsfp=2270127248"
                                  target="_blank"
                                  sx={{ fontWeight: 'bold' }}
                                >
                                  Terms of Service
                                </Link>{' '}
                              </Typography>
                            }
                            disableTypography
                          />
                        )
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} sx={{ textAlign: 'center' }}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      mt: 4,
                    }}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <CircularProgress size={24} sx={{ color: '#17ad49' }} />
                    ) : (
                      'Register Now'
                    )}
                  </Button>
                </Grid>
              </Grid>
            )}
          </Paper>
        )}
      </form>
      <Snackbar
        isOpen={alert.open}
        onClose={setAlert}
        severity={alert.status}
        message={alert.message}
      />
    </div>
  )
}

export default Regisform
